function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Service from '@ember/service';
import Kuromoji from 'kuromoji/build/kuromoji';
import { isEmpty } from '@ember/utils';
const kuromojiDictPath = 'https://dashboard-production-f.squarecdn.com/dashboard/uploads/kuromoji/dict/';
export default class ItemFuriganaService extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "kuromojiTokenizer", null);
  }
  load() {
    if (isEmpty(this.kuromojiTokenizer)) {
      return new Promise(resolve => {
        Kuromoji.builder({
          dicPath: kuromojiDictPath
        }).build((err, tokenizer) => {
          this.set('kuromojiTokenizer', tokenizer);
          resolve();
        });
      });
    }
    return new Promise(resolve => resolve());
  }
  suggestFurigana(str) {
    let suggestion = '';
    if (!isEmpty(this.kuromojiTokenizer)) {
      const path = this.kuromojiTokenizer.tokenize(str);
      suggestion = path.map(token => token.reading || token.surface_form).join('');
    }
    return suggestion;
  }
}